import { FormSubmissionStatus, useUpdateFormSubmissionStatusMutation } from '@/__generated__/types';
import { useSnackbarHelper } from '@/components/useSnackbarHelper';
import { FormControl, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { formatFormSubmissionStatus, getFormSubmissionStatusOptions } from './formUtils';

interface FormStatusSelectProps {
    submissionId: string;
    status: FormSubmissionStatus;
    onUpdated: () => void;
}

export const FormStatusSelect = ({ submissionId, status, onUpdated }: FormStatusSelectProps): JSX.Element => {
    const { showSnackbar } = useSnackbarHelper();
    const [updateStatus, { loading }] = useUpdateFormSubmissionStatusMutation();

    const handleChange = async (event: SelectChangeEvent<FormSubmissionStatus>): Promise<void> => {
        const nextStatus = event.target.value as FormSubmissionStatus;

        try {
            const { data } = await updateStatus({
                variables: {
                    submissionId,
                    status: nextStatus
                }
            });

            if (!data?.updateFormSubmissionStatus.success) {
                showSnackbar(data?.updateFormSubmissionStatus.message || 'Failed to update form status', 'error');
                return;
            }

            showSnackbar('Form status updated', 'success');
            onUpdated();
        } catch {
            showSnackbar('Failed to update form status', 'error');
        }
    };

    return (
        <FormControl size="small" fullWidth>
            <Select value={status} onChange={handleChange} disabled={loading}>
                {getFormSubmissionStatusOptions().map((option) => (
                    <MenuItem key={option} value={option}>
                        {formatFormSubmissionStatus(option)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
